export class TransitionValue
{
  property:string;
  durationMS:number;
  delayMS:number;
  timing:string;
}

export class TextFXLetter
{
  element:Element;
  letter:string;
  index:number;
  numLetters:number;
  get letterPosition()
  { return this.index / this.numLetters;}

  transitionValues:TransitionValue[] = [];

  getTransitionValue( property:string )
  {    
    let value = this.transitionValues.find( t => t.property === property );

    if ( value == null )
    {
      value = new TransitionValue();
      value.property = property;

      this.transitionValues.push( value );
    }

    return value;
  }

  setTransition( property:string, duration:number, delay:number = 0, timing:string = "ease" )
  {
    let tv = this.getTransitionValue( property );  
    tv.durationMS = duration;
    tv.delayMS = delay;
    tv.timing = timing;

    this.updateTransitionValue();
  }

  updateTransitionValue()
  {
    let htmlElement = this.element as HTMLElement;

    let style = htmlElement.style;

    let properties = this.transitionValues.map( tv => tv.property ).join( "," );
    let delay = this.transitionValues.map( tv => tv.delayMS + "ms" ).join( "," );
    let duration = this.transitionValues.map( tv => tv.durationMS + "ms" ).join( "," );
    let timing = this.transitionValues.map( tv => tv.timing ).join( "," );

    style.transitionProperty       = properties;
    style.transitionDelay          = delay;
    style.transitionDuration       = duration;
    style.transitionTimingFunction = timing;

  }
  
}